/** Colunas do order by da pesquisa das análises de mercados de clientes */
export enum ClienteAnaliseMercadoSearchClienteOrderByColumn {
    CodigoIntegracaoErpCliente = 1,
    NomeCliente = 2,
    NomeRepresentante = 3,
    QuantidadePotencial = 4,
    PesoPotencial = 5,
    ValorPotencial = 6,
    QuantidadePretendida = 7,
    QuantidadePretendidaPerc = 8,
    PesoPretendido = 9,
    PesoPretendidoPerc = 10,
    ValorPretendido = 11,
    ValorPretendidoPerc = 12,
    QuantidadeProjetada = 13,
    QuantidadeProjetadaPerc = 14,
    PesoProjetado = 15,
    PesoProjetadoPerc = 16,
    ValorProjetado = 17,
    ValorProjetadoPerc = 18,
    QuantidadeRealizada = 19,
    QuantidadeRealizadaPercPretendida = 20,
    QuantidadeRealizadaPercProjetada = 21,
    PesoRealizado = 22,
    PesoRealizadoPercPretendido = 23,
    PesoRealizadoPercProjetado = 24,
    ValorRealizado = 25,
    ValorRealizadoPercPretendido = 26,
    ValorRealizadoPercProjetado = 27,
    ClassificacaoRAP = 28,
    CadastroCliente = 29,
    SituacaoCliente = 30
};

/** Order By da pesquisa das análises de mercados de clientes */
export interface ClienteAnaliseMercadoSearchClienteOrderBy {
    column: ClienteAnaliseMercadoSearchClienteOrderByColumn;
    dir: string;
    tableOrderBy: any[];
}
